import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import Button from 'flarum/common/components/Button';
import addShopLinks from './shopLink';

// Per-post translation state, keyed by post id, so a translation survives
// redraws / the post component being remounted while scrolling the stream.
const cache = {};

// The language the viewer is reading the forum in (their Flarum UI locale).
function viewerLang() {
  const l = (document.documentElement.getAttribute('lang') || 'en').toLowerCase();
  return l.split('-')[0];
}

function toggle(post, st) {
  // Already showing → just collapse.
  if (st.open) {
    st.open = false;
    return;
  }

  st.open = true;

  // Already fetched (or in flight) → nothing more to do, just reveal it.
  if (st.text != null || st.loading) return;

  st.loading = true;
  st.error = null;

  app
    .request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/byd/translate',
      body: { html: post.contentHtml(), to: viewerLang() },
    })
    .then((res) => {
      st.loading = false;
      st.text = res.text || '';
      st.detected = res.detected || null;
      m.redraw();
    })
    .catch(() => {
      st.loading = false;
      st.error = app.translator.trans('byd-translate.forum.error');
      m.redraw();
    });
}

app.initializers.add('byd/translate', () => {
  addShopLinks();

  extend(CommentPost.prototype, 'footerItems', function (items) {
    const post = this.attrs.post;
    if (!post) return;

    const id = post.id();
    const st = cache[id] || (cache[id] = { open: false, loading: false, text: null, detected: null, error: null });

    items.add(
      'byd-translate',
      <div className="Post-translate">
        <Button
          className="Button Button--link Post-translateToggle"
          icon="fas fa-language"
          loading={st.loading}
          onclick={() => toggle(post, st)}
        >
          {st.open
            ? app.translator.trans('byd-translate.forum.hide')
            : app.translator.trans('byd-translate.forum.translate')}
        </Button>

        {st.open && st.text != null ? (
          <div className="Post-translation">
            {st.detected ? (
              <div className="Post-translation-meta">
                {app.translator.trans('byd-translate.forum.translated_note', { from: st.detected.toUpperCase() })}
              </div>
            ) : null}
            <div className="Post-translation-body">{st.text}</div>
          </div>
        ) : null}

        {st.open && st.error ? <div className="Post-translation Post-translation--error">{st.error}</div> : null}
      </div>,
      5
    );
  });
});
